import React from 'react';
import { useLocation } from 'react-use';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';

import ContactUs from '@/components/ContactUs';
import Layout from '@/components/Layout';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'path', 'form', 'contactUs'])),
    },
  };
};

const ConcatUs = () => {
  const { t } = useTranslation(['aboutus', 'common']);
  const state = useLocation();

  return (
    <div className="mb-[80px] lg:mb-[280px]">
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-联系我们-title'),
          description: t('common:seo-联系我们-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-联系我们-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-联系我们-title')}</title>
        <meta name="description" content={t('common:seo-联系我们-description')} />
        <meta name="keywords" content={t('common:seo-联系我们-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-联系我们-title')}
        />
      </Head>
      <ContactUs />
    </div>
  );
};

export default ConcatUs;

ConcatUs.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
